import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const AdminProductsService = {
  getProducts,
  getProductCategory,
  getBrandsByid,
  getBrands,
  getBrandselect,
  tambahproduk,
  editproduk,
  tambahbrand,
  editbrand,
  getBrandGroups,
  tambahbrandgroup,
  editbrandgroup
}
function tambahbrand (postdata) {
  return fetch(API_URL + '/api/admin/v1/brand', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function editbrand (postdata) {
  return fetch(API_URL + '/api/admin/v1/brand', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function editproduk (postdata) {
  return fetch(API_URL + '/api/admin/v1/product', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function tambahproduk (postdata) {
  return fetch(API_URL + '/api/admin/v1/product', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getProducts (opsi) {
  if (opsi.brandid === null || opsi.brandid === undefined) {
    opsi.brandid = ''
  }
  if (opsi.categoryid === null || opsi.categoryid === undefined) {
    opsi.categoryid = ''
  }
  if (opsi.search === null) {
    opsi.search = ''
  }
  if (opsi.itemsPerPage < 0) {
    opsi.itemsPerPage = 10000
  }
  const page = opsi.page - 1
  var sort = 'productcode'
  var sorder = 'DESC'
  sorder = 'ASC'
  const sorting = 'brand.brandname,ASC&sort=' + sort + ',' + sorder
  return fetch(API_URL + '/api/admin/v1/product?search=' + opsi.search + '&categoryid=' + opsi.categoryid + '&brandid=' + opsi.brandid + '&size=' + opsi.itemsPerPage + '&page=' + page + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getProductCategory (opsi) {
  if (opsi === undefined) {
    opsi = {
      search: '',
      itemsPerPage: 50,
      page: 1,
      status: '',
      sortBy: ['id']
    }
  }
  if (opsi.itemsPerPage < 0) {
    opsi.itemsPerPage = 10000
  }
  const page = opsi.page - 1
  return fetch(API_URL + '/api/admin/v1/category?search=&size=' + opsi.itemsPerPage + '&page=' + page, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getBrandsByid (id) {
  return fetch(API_URL + '/api/v1/product/brand/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getBrandselect (opsi) {
  if (opsi === undefined) {
    opsi = {
      search: '',
      itemsPerPage: 10,
      page: 1,
      status: '',
      sortBy: ['id']
    }
  }
  if (opsi.itemsPerPage < 0) {
    opsi.itemsPerPage = 10000
  }
  const page = opsi.page - 1
  if (opsi.search === null) {
    opsi.search = ''
  }
  return fetch(API_URL + '/api/admin/v1/brand?search=' + opsi.search + '&size=500&page=' + page, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getBrandGroups (opsi) {
  if (opsi === undefined) {
    opsi = {
      search: '',
      itemsPerPage: 100,
      page: 1,
      status: '',
      sortBy: ['id']
    }
  }
  if (opsi.itemsPerPage < 0) {
    opsi.itemsPerPage = 10000
  }
  const page = opsi.page - 1
  if (opsi.search === null) {
    opsi.search = ''
  }
  let categoryid = opsi.categoryid
  if (opsi.categoryid === null || opsi.categoryid === undefined) {
    categoryid = ''
  }
  return fetch(API_URL + '/api/admin/v1/brandgroup?search=' + opsi.search + '&size=' + opsi.itemsPerPage + '&page=' + page + '&categoryid=' + categoryid, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getBrands (opsi) {
  if (opsi === undefined) {
    opsi = {
      search: '',
      itemsPerPage: 10,
      page: 1,
      status: '',
      sortBy: ['id']
    }
  }
  if (opsi.itemsPerPage < 0) {
    opsi.itemsPerPage = 10000
  }
  const page = opsi.page - 1
  if (opsi.search === null) {
    opsi.search = ''
  }
  return fetch(API_URL + '/api/admin/v1/brand?search=' + opsi.search + '&size=' + opsi.itemsPerPage + '&page=' + page, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function tambahbrandgroup (postdata) {
  return fetch(API_URL + '/api/admin/v1/brandgroup', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function editbrandgroup (postdata) {
  return fetch(API_URL + '/api/admin/v1/brandgroup', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
